// extracted by mini-css-extract-plugin
export var centerText = "_f2-8";
export var container = "_f2-0";
export var doughnutContainer = "_f2-7";
export var legend = "_f2-a";
export var legendItemColorDisplay = "_f2-b";
export var legendItemLabel = "_f2-d";
export var legendItemValue = "_f2-c";
export var lg = "_f2-5";
export var maxWidth = "_f2-9";
export var md = "_f2-4";
export var responsive = "_f2-6";
export var sm = "_f2-3";
export var xs = "_f2-2";
export var xxs = "_f2-1";